import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-analytics-sub-menu',
  templateUrl: './analytics-sub-menu.component.html',
  styleUrls: ['./analytics-sub-menu.component.css'],
})
export class AnalyticsSubMenuComponent {
  subMenuItems = [
    {
      image: '',
      name: 'Partner',
      route: 'bank',
    },
    // {
    //   image: '',
    //   name: 'API User',
    //   route: 'api',
    // },
    {
      image: '',
      name: 'Reseller',
      route: 'agent',
    },
    {
      image: '',
      name: 'Merchant',
      route: 'merchant',
    },

    {
      image: '',
      name: 'General Analytics',
      route: 'general',
    },
  ];

  constructor(public router: Router) {}
}
